/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IVinhusetNavigationMenu contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum menuItemsSource {
    categories = 'categories',
    static = 'static'
}

export interface IVinhusetNavigationMenuConfig extends Msdyn365.IModuleConfig {
    menuItemsSource?: menuItemsSource;
    cmsNavItems?: ICmsNavItemsData[];
    productsMenuItemPosition?: number;
    showProductsMenuItemOnlyAuthorized?: boolean;
    showAllProductsLink?: Msdyn365.ILinkData;
    showAllProductsLabel?: string;
    className?: string;
    clientRender?: boolean;
}

export interface IVinhusetNavigationMenuResources {
    productsMenuItemLabel: string;
    menuAriaLabel: string;
    navigationOverflowButtonLabel: string;
}

export interface ICmsNavItemsData {
    linkText?: string;
    linkUrl?: Msdyn365.ILinkData;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    ariaLabel?: string;
    openInNewTab?: boolean;
    showOnlyAuthorized?: boolean;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    showOnlyAuthorized?: boolean;
    subMenus?: ISubMenusData[];
}

export interface ISubMenusData {
    linkText?: string;
    linkUrl: Msdyn365.ILinkData;
    ariaLabel?: string;
    image?: Msdyn365.IImageData;
    imageLink?: Msdyn365.ILinkData;
    showOnlyAuthorized?: boolean;
}

export interface IVinhusetNavigationMenuProps<T> extends Msdyn365.IModule<T> {
    resources: IVinhusetNavigationMenuResources;
    config: IVinhusetNavigationMenuConfig;
}
